import { PROPERTY_LOADER } from "../../constants";
import styles from "./Loader.module.scss";

const Loader = () => {
  return (
    <main className={styles.loaderContainer}>
      <img src={PROPERTY_LOADER} />
    </main>
  );
};

export default Loader;
